import { useState, useEffect, useCallback, useMemo } from 'react';
import InputElement from '../../../Common/InputElement';
import ButtonElement from '../../../Common/ButtonElement';
import { useApiRequest } from '../../../hooks/useApiRequest';
import { appApis } from '../../../constants';
import ToggleSwitch from '../../../Common/Checkbox';
import { commonOnChange, validateFields } from '../../../utils';
import { FiPhone } from 'react-icons/fi';
import FrequencySelector from './FrequencySelectory';
import LoadingElement from '../../../Common/LoadingElement';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { GoPerson } from 'react-icons/go';

const Settings = () => {
  const [formData, setFormData] = useState({
    status: false,
    id: null,
    mobileNo: '',
    userName: '',
    password: '',
    frequency: 3,
    mobileNoErr: false, 
    userNameErr: false, 
    passwordErr: false, 
  });
  const [showPassword, setShowPassword] = useState(false);
  const { request, loading } = useApiRequest();
  const { request: submitRequest, loading: submitLoading } = useApiRequest();

  const handleInputChange = (e) => commonOnChange(e, setFormData);
  const isUpdate = useMemo(() => formData?.id ?? null, [formData])

  const fetchProfileData = async () => {
    await request({
      url: appApis.getWpSettings,
      showToast: false,
      onSuccess: (response) => {
        if (response?.data) {
          const profileData = response.data ?? {};
          setFormData(prev => ({...prev,
            id: profileData?.id ?? null,
            userName: profileData.username || '',
            password: profileData.password || '',
            mobileNo: profileData.mobileNumber || '',
            frequency: profileData.reminderFrequencyDays || '',
            status: profileData.enableReminder ?? false
          }));

          setShowPassword(false);
        }
      }
    });
  };

    const submitSettings = useCallback(() => {
        const { mobileNo, userName, password, frequency, status } = formData;
        validateFields(
            {
                mobileNoErr: [mobileNo, "phone"],
                userNameErr: [userName, "text"],
                passwordErr: [password, "text"],
            },
            setFormData,
            () => {
                submitRequest({
                    url: isUpdate ? appApis.updateWpSettings : appApis.createWpSettings,
                    method: isUpdate ? "PUT" : "POST",
                    body: {
                      username: userName,
                      password,
                      mobileNumber: mobileNo,
                      enableReminder: status,
                      reminderFrequencyDays: frequency
                    },
                    onSuccess: fetchProfileData
                })
            })
    }, [formData])

  useEffect(() => {
    fetchProfileData();
  }, []);

  return (
    loading ? <LoadingElement /> : <div className="container-fluid my-3 px-sm-5 px-2">
      <div className="row">
        <div className="col-12">
          <div className="card shadow-sm border-0 rounded">
            {/* Header */}
            <div className="card-header bg-white border-0 p-4">
              <div className="d-flex align-items-center justify-content-between">
                {/* {renderLogo()} */}
                <div>
                  <h2 className="fw-bold mb-1">WhatsApp Setting</h2>
                  <p className="text-muted mb-0">Enables the delivery of scheduled reminders to your WhatsApp.</p>
                </div>
                <ToggleSwitch value={formData?.status} onChange={(value) => handleInputChange({ target: { name: "status", value }})} />
              </div>
            </div>

            {/* Form Content */}
            {(isUpdate || formData?.status) ? <div className="card-body p-4">
              <div className="row g-4">
                {/* Company Information */}
                <div className="col-12">
                  <InputElement
                    type='phone'
                    label="WhatsApp Number"
                    placeholder="Enter WhatsApp Number"
                    name="mobileNo"
                    icon={<FiPhone size={20} />}
                    error={formData.mobileNoErr}
                    value={formData.mobileNo}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-6">
                  <InputElement
                    type='phone'
                    label="User Name"
                    placeholder="Enter User Name"
                    name="userName"
                    error={formData.userNameErr}
                    value={formData.userName}
                    onChange={handleInputChange}
                    icon={<GoPerson size={20} />}
                  />
                </div>
                <div className="col-md-6">
                  <InputElement
                    label="Password"
                    placeholder="Enter Password"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    error={formData.passwordErr}
                    onChange={handleInputChange}
                    icon={showPassword ? <BsEyeSlash size={20} onClick={() => setShowPassword(!showPassword)} /> : <BsEye size={20} onClick={() => setShowPassword(!showPassword)} />}
                  />
                </div>

                <FrequencySelector frequency={formData?.frequency || 3} onFrequencyChange={(value) => handleInputChange({ target: { name: "frequency", value }})} />
              </div>

              {/* Action Buttons */}
              <div className="text-center mt-4 pt-3 border-top">
                <ButtonElement
                  text={submitLoading ? "Saving..." : "Save Changes"}
                  onClick={submitSettings}
                  variant="btn-primary"
                  cssClass="px-4 py-2"
                />
              </div>
            </div> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;